import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import { BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { first } from "rxjs/operators";
import { RoleMgr } from "../../core";
import { ScoutPath, ScoutPoint } from "../../core/models/scout-task";
import { TaskStatus } from "../../core/models/task-status";
import { ScoutTaskDoc } from "../../core/schema/scout-task-schema";
import { ContextByPhotoId, ScoutPhotoGroupDef, ScoutPointPhotoSelected } from "../scout-point/scout-point-photo-browser/scout-point-photo-browser.component";
import { ScoutPointPhotoModal } from "../scout-point/scout-point-photo-modal/scout-point-photo-modal.component";
import { ScoutPointRefDialogComponent } from "../scout-point/scout-point-ref-dialog/scout-point-ref-dialog.component";
import { ScoutPointPhotoDoc } from "../../core/schema/scout-point-photo-schema";


export interface PhotoCellContextInterface{
  iconCssClass:string;
};

export class DefaultCellContext implements PhotoCellContextInterface {
 iconCssClass:string;
};

export type PhotoContextEvent<ContextType=any> = {
  photo : ScoutPointPhotoDoc;
  grpDef: ScoutPhotoGroupDef;
  contextByPhotoId: ContextByPhotoId<ContextType>;
};

@Component({
  selector: "app-scout-point-photo-links",
  templateUrl: "./scout-point-photo-links.component.html",
  styleUrls: ["./scout-point-photo-links.component.scss"],
})
export class ScoutPointPhotoLinksComponent<ContextType extends PhotoCellContextInterface=DefaultCellContext> implements OnInit, OnDestroy {
  @Input() scoutTask: ScoutTaskDoc;
  @Input() scoutPath: ScoutPath;
  @Input() scoutPoint: ScoutPoint;
  @Input() bShowPhotoSummary: boolean;
  @Input() uiLocked = false;
  @Input() photoBtnContentTmplRef: TemplateRef<PhotoContextEvent>;
  @Input() bindContextFn: (photos: ScoutPointPhotoDoc[], contextByPhotoId: {[id:string]:ContextType}) => Promise<void>;
  @Output() photoIconDblClick = new EventEmitter<PhotoContextEvent>();
  @Output() contextBound = new EventEmitter<{[photoId:string]: ContextType}>();
  @Output("scoutPointIdSelected") scoutPointIdSelected$ =
    new EventEmitter<string>();

  constructor(
    public roleMgr: RoleMgr,
    protected bsModalService: BsModalService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  onShowScoutPointPhoto = (photoSelectedEvt: ScoutPointPhotoSelected) => {
    //console.log( JSON.stringify(photoSelectedEvt.photo.toJSON()))
    this.scoutPointIdSelected$.next(photoSelectedEvt.point?.id);
    let uiLocked = TaskStatus.uiLockHandler(
      photoSelectedEvt.path?.statusId,
      this.roleMgr.canEditUsers
    );
    const context: ModalOptions = {
      initialState: {
        locked: uiLocked,
        ...photoSelectedEvt,
      },
      class: "photo-modal",
      id: ScoutPointPhotoModal.ModalId,
      animated: true,
      ignoreBackdropClick: true,
    };
    const modalRef = this.bsModalService.show(ScoutPointPhotoModal, context);
  };

  onShowScoutPoint = (scoutPoint: ScoutPoint, scoutPath: ScoutPath) => {
    this.scoutPointIdSelected$.next(scoutPoint?.id);
    let uiLocked = TaskStatus.uiLockHandler(
      scoutPath.statusId,
      this.roleMgr.canEditUsers
    );
    const context: ModalOptions = {
      initialState: {
        scoutPointId: scoutPoint.id,
        scoutPathId: scoutPath.id,
        scoutTaskDoc: this.scoutTask,
        allowEditMode: true,
        locked: uiLocked,
      },
      class: "full-screen-modal",
      id: ScoutPointRefDialogComponent.ModalId,
      animated: true,
      ignoreBackdropClick: true,
    };
    const modalRef = this.bsModalService.show(
      ScoutPointRefDialogComponent,
      context
    );
    this.scoutModal = modalRef.content;
    const pointChangeSubscription =
      this.scoutModal.selectedPointChanged.subscribe((pt: ScoutPoint) => {
        this.scoutPointIdSelected$.next(pt?.id);
      });
    this.scoutModal.onClosed.pipe(first()).subscribe(() => {
      this.scoutModal = null;
      pointChangeSubscription?.unsubscribe();
    });
  };
  scoutModal: ScoutPointRefDialogComponent;
}
